import React, { useEffect, useState } from "react";

import { useNavigate, useParams } from "react-router-dom";
import { Button, Form, FormGroup, FormLabel } from "react-bootstrap";
import { FormikProvider, useFormik, Field } from "formik";
import FormSelectField from "../../Components/FormSelectField";
import { ErrorAlert } from "../../Components/ErrorAlert";
import User from "../../Services/userServices";
import Branch from "../../Services/branchServices";
import { Select, Space, message, SelectProps } from "antd";
import { userRoles } from "../../config/EnVariables";

const options: SelectProps['options'] = [
  {
    label: 'CREATE',
    value: 'CREATE',
    emoji: 'create',
    desc: 'CREATE',
  },
  {
    label: 'READ',
    value: 'READ',
    emoji: 'read',
    desc: 'READ',
  },
  {
    label: 'UPDATE',
    value: 'UPDATE',
    emoji: 'update',
    desc: 'UPDATE',
  },
  {
    label: 'DELETE',
    value: 'DELETE',
    emoji: 'delete',
    desc: 'DELETE',
  },
];
function AddUser(props) {
  const { edit } = props;

  const userId = useParams().id;

  const navigate = useNavigate();
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [branches, setBranches] = useState([]);
const [permissions, setPermissions] = useState()
  const getUserEdit = async () => {
    if (edit && userId) {
      setLoading(true);
      await User.getOne(userId)
        .then((data) => {
          setLoading(false);
          setFieldValue("branchId", data.data.branchId);
          setFieldValue("name", data.data.name);
          setFieldValue("username", data.data.username);
          setFieldValue("email", data.data.email);
          setFieldValue("phone", data.data.phone);
          setFieldValue("address", data.data.address);
          setFieldValue("role", data.data.role);
          setFieldValue("permissions", data.data.permissions);
        })
        .catch((err) => {
          setLoading(false);
          setError(true);
          console.log(err);
        });
    }
  };
  const getAllBranches = () => {
    Branch.getAllBranches().then((b) => {
      console.log(b.data);
      setBranches(b.data);
    });
  };
  useEffect(() => {
    getAllBranches();
  }, []);
  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      phone: "",
      password: "",
      address: "",
      role: "",
      permissions: [],
    },
    onSubmit: (values, { setSubmitting, setFieldError }) => {
      if(userId) values.id = userId;
      values.permissions = permissions.map((p)=>({
        name: p
      }))
      if (userId) {
        User.update(values)
          .then((data) => {
            message.success("Saved Successfully");
            navigate("/user-list");
            console.log(data);
          })
          .catch((err) => {
            console.log(err);
          });
      } else
        User.addUser(values)
          .then((data) => {
            message.success("Saved Successfully");
            navigate("/user-list");
            console.log(data);
          })
          .catch((err) => {
            console.log(err);
          });
    },
  });

  const { handleSubmit, setFieldValue } = formik;

  useEffect(() => {
    getUserEdit();
  }, []);

  return (
    <>
      {loading && (
        <div id="global-loader">
          <div class="whirly-loader"> </div>
        </div>
      )}
      <div class="page-wrapper">
        <div class="content">
          <div class="page-header">
            <div class="page-title">
              <h4>User Management</h4>
              <h6>Add/Update User</h6>
            </div>
          </div>

          <div class="card">
            <div class="card-body">
              {!error && (
                <FormikProvider value={formik}>
                  <Form autoComplete="off" onSubmit={handleSubmit}>
                    <FormGroup className="mb-3">
                      <div class="row">
                        <div class="col-lg-3 col-sm-6 col-12">
                          <div class="form-group">
                            <FormLabel>Branch</FormLabel>
                            <FormSelectField type="select" name="branchId">
                              <option value="">Select</option>
                              {branches.map((item) => {
                                return (
                                  <option value={item.id}>{item.name}</option>
                                );
                              })}
                            </FormSelectField>
                          </div>
                        </div>
                        <div class="col-lg-3 col-sm-6 col-12">
                          <div class="form-group">
                            <FormLabel>Name</FormLabel>
                            <Field type="text" name="name" required />
                          </div>
                        </div>
                        <div class="col-lg-3 col-sm-6 col-12">
                          <div class="form-group">
                            <FormLabel>Username</FormLabel>
                            <Field type="text" name="username" required disabled={userId && true}/>
                          </div>
                        </div>
                        <div class="col-lg-3 col-sm-6 col-12">
                          <div class="form-group">
                            <FormLabel>Email</FormLabel>
                            <Field name="email" type="email" required />
                          </div>
                        </div>
                        <div class="col-lg-3 col-sm-6 col-12">
                          <div class="form-group">
                            <FormLabel>Phone</FormLabel>
                            <Field
                              type="text"
                              name="phone"
                              pattern="^((\+93))(7)([0-9]{8})$"
                              placeholder="+93700000000"
                              required
                            />
                          </div>
                        </div>
                        {/* <div class="col-lg-3 col-sm-6 col-12"> */}
                        {/* <div class="form-group">
                        <FormLabel>Password</FormLabel>
                        <div class="pass-group">
                          <Field type="password" class=" pass-input" name="password" required/>
                          <span class="fas toggle-password fa-eye-slash"></span>
                        </div>
                      </div> */}
                        {/* </div> */}
                        <div class="col-lg-3 col-sm-6 col-12">
                          <div class="form-group">
                            <FormLabel>Password</FormLabel>
                            <Field
                              type="password"
                              name="password"
                              required
                              disabled={edit}
                            />
                          </div>
                        </div>
                        <div class="col-lg-3 col-sm-6 col-12">
                          <div class="form-group">
                            <FormLabel>Address</FormLabel>
                            <Field name="address" type="text" required />
                          </div>
                        </div>
                        <div class="col-lg-3 col-sm-6 col-12">
                          <div class="form-group">
                            <FormLabel>Role</FormLabel>
                            <FormSelectField type="select" name="role">
                              <option>Select</option>
                              {Object.keys(userRoles).map((item) => {
                                return (
                                  <option value={item}>{item}</option>
                                );
                              })}
                            </FormSelectField>
                          </div>
                        </div>
                        <div class="col-lg-3 col-sm-6 col-12">
                          <div class="form-group">
                            <FormLabel>Permissions</FormLabel>
                            {/* <FormSelectField
                              type="select"
                              name="permissions"
                              mode="multiple"
                            >
                              <option>Select</option>
                              {userPermissions.map((item) => {
                                return (
                                  <option value={item.id}>{item.name}</option>
                                );
                              })}
                            </FormSelectField> */}
                            <Select
    mode="multiple"
    style={{ width: '100%' }}
    placeholder="select one country"
    defaultValue={['READ']}
    onChange={(val)=>setPermissions(val)}
    optionLabelProp="label"
    options={options}
    optionRender={(option) => (
      <Space>
        <span role="img" aria-label={option.data.label}>
          {option.data.emoji}
        </span>
        {option.data.desc}
      </Space>
    )}
  />
                          </div>
                        </div>

                        <div class="col-lg-12">
                          <Button className="btn btn-submit me-2" type="submit">
                            Submit
                          </Button>
                          <Button href="user-list" className="btn btn-cancel">
                            Cancel
                          </Button>
                        </div>
                      </div>
                    </FormGroup>
                  </Form>
                </FormikProvider>
              )}
              {error && <ErrorAlert heading={"User not found"}></ErrorAlert>}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddUser;
